import { Link, NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";
import { ShoppingBag, User, LogOut } from "lucide-react";
import Logo from "./Logo";
import { hasAccess } from "@/lib/roles";

export default function Navbar() {
  const { user, logout } = useAuth();
  const { count } = useCart();

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-xl border-b border-navy-10" style={{ borderColor: "rgba(10,37,64,0.10)" }}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <div className="relative flex items-center justify-center transition-transform duration-500 group-hover:scale-[1.03]">
            <Logo size={42} />
          </div>
          <div className="leading-tight">
            <div className="font-serif text-xl text-navy tracking-tight">Aperture</div>
            <div className="eyebrow" style={{ fontSize: "0.55rem", letterSpacing: "0.3em" }}>Enterprises</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-10 text-sm">
          <NavLink to="/catalog" data-testid="nav-catalog" className={({isActive}) => `text-navy hover:text-gold transition-colors duration-300 ${isActive ? "text-gold" : ""}`}>Catalog</NavLink>
          <NavLink to="/affiliates" data-testid="nav-affiliates" className={({isActive}) => `text-navy hover:text-gold transition-colors duration-300 ${isActive ? "text-gold" : ""}`}>Affiliates</NavLink>
          {!hasAccess(user?.role, "admin") && <NavLink to="/library" data-testid="nav-library" className={({isActive}) => `text-navy hover:text-gold transition-colors duration-300 ${isActive ? "text-gold" : ""}`}>My Library</NavLink>}
          {hasAccess(user?.role, "admin") && <NavLink to="/admin" data-testid="nav-admin" className="text-gold font-medium">Admin</NavLink>}
        </nav>

        <div className="flex items-center gap-4">
          <Link to="/cart" data-testid="nav-cart" className="relative p-2 text-navy hover:text-gold transition-colors duration-300">
            <ShoppingBag className="w-5 h-5" strokeWidth={1.5} />
            {count > 0 && (
              <span data-testid="cart-count" className="absolute -top-0 -right-0 bg-gold text-navy text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
                {count}
              </span>
            )}
          </Link>
          {user ? (
            <div className="flex items-center gap-3">
              <span className="hidden sm:block text-xs text-navy/70">{user.email}</span>
              <button data-testid="nav-logout" onClick={logout} className="p-2 text-navy hover:text-gold transition-colors duration-300">
                <LogOut className="w-4 h-4" strokeWidth={1.5} />
              </button>
            </div>
          ) : (
            <Link to="/login" data-testid="nav-login" className="hidden sm:flex items-center gap-1.5 text-navy hover:text-gold transition-colors duration-300 text-sm">
              <User className="w-4 h-4" strokeWidth={1.5} /> Sign in
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
